{
  "account": {
    "heading": "Profile",
    "profile_section": {
      "name": "Full name",
      "email": "Email",
      "save": "Done",
      "success_toast": "✨ Profile updated!"
    },
    "password_section": {
      "heading": "Password",
      "success_toast": "✨ Password changed!",
      "save": "Save",
      "current_password": "Current password",
      "password": "New password",
      "confirm": "Confirm password"
    }
  },
  "subscription": {
    "heading": "Personal account",
    "section_heading": "Personal account",
    "badge": {
      "current_plan": "Current plan",
      "personal_plan": "Personal plan"
    },
    "plan": {
      "free": "Free",
      "plus": "Plus",
      "plus_renews": "Renews {{date}}.",
      "plus_active_through": "Active through {{date}}.",
      "plus_ending": "Access ends {{date}}. It will not renew.",
      "manage": "Manage subscription",
      "contact_support": "<0>Contact support</0> to manage this subscription.",
      "resume": "Resume subscription",
      "update_payment": "Update payment method",
      "reactivate": "Reactivate"
    },
    "inherited": {
      "business_title": "Plus access included through {{name}}",
      "business_description": "Your Organization membership unlocks Plus features while you remain a member.",
      "family_title": "Plus access included through your {{name}} subscription",
      "family_description": "Your Family membership unlocks Plus features while you remain a member.",
      "family_owner_description": "Billing for this Family subscription lives in its account.",
      "view_account": "View your Family account"
    },
    "upgrade": {
      "heading": "Upgrade your plan",
      "billing_interval": "Billing interval",
      "monthly": "Monthly",
      "annual": "Annual",
      "recommended": "Recommended",
      "plus": {
        "name": "Plus",
        "seats": "1 account",
        "feature_magic": "Unlimited Magic: text, photos and PDFs",
        "feature_co_editors": "Unlimited co-editors",
        "feature_sources": "Unlimited sources and feeds",
        "cta": "Choose Plus"
      },
      "family": {
        "name": "Family",
        "seats": "6 accounts included",
        "feature_everything": "Everything in Plus",
        "feature_reminders": "Text reminders for your family (US numbers only)",
        "feature_calendars": "Shared family calendars",
        "cta": "Upgrade to Family"
      }
    },
    "family_promo": {
      "heading": "Bring Plus home to your family.",
      "body": "Family keeps your Plus benefits and adds a private workspace for up to six people, shared calendars, and text reminders.",
      "body_manual": "You can still purchase Family yourself. It keeps your Plus benefits and adds a private workspace for up to six people, shared calendars, and text reminders.",
      "button": "Upgrade to Family"
    },
    "current_plan": {
      "heading": "Current plan",
      "free": "You are currently on the Free plan.",
      "plus": "You are currently on the Plus plan.",
      "family": "You are currently on the Family plan."
    },
    "subscribed_section": {
      "heading_plus": "Thank you for being a Plus subscriber!",
      "heading_family": "Thank you for being a Family subscriber!",
      "subscription_period": "You're subscribed through {{date}}.",
      "manage": "Manage subscription",
      "contact_support": "Contact support to manage your subscription"
    },
    "interrupted": {
      "badge_past_due": "Payment failed",
      "badge_expired": "Expired",
      "past_due_title": "Your {{plan}} plan is paused",
      "past_due_body": "A payment didn't go through, so Plus features are unavailable until it's sorted. Your calendars, views and collaborators are all still here.",
      "lapsed_title": "Your {{plan}} plan ended",
      "lapsed_body": "Ended {{date}}. Everything you built is still here — reactivate to use Plus features again.",
      "lapsed_body_no_date": "Everything you built is still here — reactivate to use Plus features again.",
      "inherited_title": "Plus access through {{name}} ended",
      "inherited_body_family": "This Family plan no longer includes Plus for you. The plan's owner can reactivate it, or you can get your own.",
      "inherited_body_business": "This Organization plan no longer includes Plus for you. The plan's owner can reactivate it, or you can get your own.",
      "view_workspace": "View workspace"
    },
    "plan_names": {
      "PLUS": "Plus",
      "FAMILY": "Family",
      "BUSINESS": "Organization"
    }
  },
  "help": {
    "heading": "Help & support",
    "documentation": "Documentation",
    "documentationLink": "Visit the help center",
    "support": "Support",
    "version": "Version",
    "release": "Release v{{version}}-{{release}}",
    "delete_account": {
      "link": "Delete account",
      "title": "Delete your account?",
      "blocked_title": "You can't delete your account yet",
      "blocked_intro": "Other people depend on these organizations. Transfer or cancel them, then try again:",
      "hint_shared_organization": "Transfer ownership of this organization, or remove its other members.",
      "hint_paid_shared_organization": "This organization's plan is billed to you, so transferring ownership isn't enough. Cancel the plan or contact support.",
      "warning": "This permanently deletes your account, {{schedules}} and {{planners}}. It can't be undone.",
      "schedule_count_one": "{{count}} schedule",
      "schedule_count_other": "{{count}} schedules",
      "planner_count_one": "{{count}} planner",
      "planner_count_other": "{{count}} planners",
      "shared_items_intro": "These are shared with other people, who will lose access:",
      "untitled": "Untitled",
      "subscription_warning": "Your {{plan}} plan ends immediately. You won't be refunded for the rest of the billing period.",
      "feeds_warning_one": "{{count}} schedule other people own will stop syncing your calendar.",
      "feeds_warning_other": "{{count}} schedules other people own will stop syncing your calendar.",
      "confirmation_label": "Type your email address or DELETE to confirm",
      "confirmation_mismatch": "Type your email address or DELETE exactly.",
      "load_error": "We couldn't check your account. Please try again.",
      "cancel": "Cancel",
      "close": "Close",
      "submit": "Delete account",
      "success_toast": "Your account has been deleted."
    }
  },
  "calendars": {
    "heading": "External calendars",
    "benefits_heading": "Connect your Google Calendar for an even better experience!",
    "benefits_heading_any_provider": "Connect a calendar for an even better experience!",
    "connect_google": "Connect a Google Calendar",
    "connect_google_another": "Connect another Google Calendar",
    "connect_outlook": "Connect an Outlook Calendar",
    "connect_outlook_another": "Connect another Outlook Calendar",
    "google_limited_use": "Agenda Hero's use and transfer of information received from Google APIs to any other app will adhere to <2>Google API Services User Data Policy</2>, including the Limited Use requirements.",
    "microsoft_apis_terms": "Agenda Hero's use of information received from Microsoft APIs adheres to the <2>Microsoft APIs Terms of Use</2>.",
    "integrations_loading": "Loading calendars...",
    "integrations_error": "Error loading calendars",
    "confirm_disconnect": {
      "title": "Disconnect this account?",
      "submit": "Disconnect",
      "error_toast": "Error disconnecting account"
    },
    "disconnect": "Disconnect",
    "schedule_count_one": "{{count}} schedule",
    "schedule_count_other": "{{count}} schedules",
    "planner_count_one": "{{count}} planner",
    "planner_count_other": "{{count}} planners",
    "used_in": "used in {{usage}}",
    "used_in_both": "used in {{schedules}} and {{planners}}"
  },
  "organizations": {
    "loading": "Loading organizations...",
    "error": "Error loading organizations",
    "members_section": "Members",
    "invites_section": "Pending invitations",
    "members_error": "Error loading members",
    "members_count_one": "{{count}} member",
    "members_count_other": "{{count}} members",
    "workspace": {
      "label_family": "Family workspace",
      "label_business": "Organization workspace",
      "accounts_used": "{{used}} of {{limit}} accounts used",
      "seats_used": "{{used}} of {{limit}} accounts used"
    },
    "plan": {
      "name_family": "Family",
      "name_business": "Organization",
      "name_plus": "Plus",
      "badge_active": "Active",
      "badge_ending": "Ending",
      "renewal": "Renews {{date}}. {{detail}}",
      "ending": "Access ends {{date}}. {{detail}}",
      "subscribed": "Active through {{date}}. {{detail}}",
      "family_access_note": "Everyone in this workspace receives Plus access.",
      "seat_composition_zero": "{{included}} base accounts.",
      "seat_composition_one": "{{included}} base accounts plus {{count}} pack of {{packSize}} accounts.",
      "seat_composition_other": "{{included}} base accounts plus {{count}} packs of {{packSize}} accounts.",
      "manage": "Manage subscription",
      "badge_past_due": "Payment failed",
      "badge_expired": "Expired",
      "past_due": "A payment didn't go through, so Plus is unavailable for this workspace. {{detail}}",
      "expired": "Ended {{date}}. {{detail}}",
      "expired_no_date": "This plan has ended. {{detail}}",
      "members_kept": "Everyone is still here and nothing has been removed.",
      "update_payment": "Update payment method",
      "reactivate": "Reactivate plan"
    },
    "member_view": {
      "access_title": "Plus access included through {{name}}",
      "access_family": "This Family plan includes Plus access for you.",
      "access_business": "This Organization plan includes Plus access for you.",
      "plan": "Workspace plan",
      "renews": "Renews",
      "ends": "Access ends",
      "active_through": "Active through",
      "role": "Your role",
      "role_member": "Member",
      "ended": "Access ended",
      "interrupted_title_past_due": "Plus access through {{name}} is paused",
      "interrupted_title_expired": "Plus access through {{name}} has ended",
      "interrupted_body": "The plan's owner can restore it. You keep everything you've made either way."
    },
    "seats": {
      "heading": "Accounts",
      "description": "Review your current capacity or make an occasional adjustment.",
      "current_heading": "Current accounts",
      "current_summary": "{{licensed}} licensed · {{inUse}} in use",
      "adjust_button": "Adjust accounts",
      "close": "Close",
      "adjust": {
        "heading": "New account total",
        "composition_base": "{{included}} base accounts",
        "composition_packs_one": "{{included}} base accounts + {{count}} pack of {{packSize}}",
        "composition_packs_other": "{{included}} base accounts + {{count}} packs of {{packSize}}",
        "decrease": "Remove {{count}} accounts",
        "increase": "Add {{count}} accounts",
        "note_unchanged": "No changes scheduled. Account changes take effect at renewal.",
        "note_increase": "Adds {{seats}} accounts now. You'll be charged a prorated amount for the rest of this period.",
        "note_decrease": "Takes effect {{date}} at renewal.",
        "note_invalid": "Choose at least {{seats}} accounts, or remove members first.",
        "error_title": "Account count is below current membership",
        "error_body_one": "You have {{count}} current member. Remove {{excess}} member before reducing to {{seats}} accounts.",
        "error_body_other": "You have {{count}} current members. Remove {{excess}} members before reducing to {{seats}} accounts.",
        "submit_add": "Add accounts now",
        "submit_schedule": "Schedule account change",
        "cancel": "Cancel",
        "add_success": "Added {{seats}} accounts",
        "add_error": "Error adding accounts",
        "add_error_payment": "The payment didn't go through. Update your payment method in the billing portal and try again.",
        "add_error_pending": "You have a scheduled account change. Cancel it before adding accounts.",
        "schedule_success": "Account change scheduled",
        "schedule_error": "Error scheduling the account change",
        "blocked": "Remove members or pending invites first: your organization is using more accounts than the reduced count allows.",
        "pending_banner": "Your accounts decrease to {{seats}} on {{date}}.",
        "pending_keep": "Keep my accounts",
        "pending_keep_success": "Scheduled account change canceled",
        "pending_keep_error": "Error canceling the scheduled account change"
      }
    },
    "name": {
      "edit": "Edit organization name",
      "save": "Save",
      "cancel": "Cancel",
      "success": "Organization name updated",
      "error": "Error updating organization name"
    },
    "invite": {
      "heading_family": "Invite family members",
      "button_family": "Invite people",
      "button_business": "Invite members",
      "spaces_available_one": "One space is available.",
      "spaces_available_other": "{{count}} spaces are available.",
      "seats_available": "Invite people while accounts are available.",
      "limit_reached": "This organization has no accounts remaining",
      "placeholder": "Email addresses",
      "submit": "Send invitations",
      "cancel": "Cancel",
      "success_one": "Invitation sent to {{email}}",
      "success_other": "{{count}} invitations sent",
      "error": "Error sending invitation",
      "all_existing": "Everyone entered is already a member or invited",
      "skipped_one": "{{count}} invitation wasn't sent because there are no accounts remaining",
      "skipped_other": "{{count}} invitations weren't sent because there are no accounts remaining",
      "plan_inactive_family": "Reactivate this plan to add family members.",
      "plan_inactive_business": "Reactivate this plan to add members."
    },
    "invite_family": {
      "name": {
        "label": "Name"
      },
      "email": {
        "label": "Email address"
      },
      "phone": {
        "label": "Phone number",
        "invalid": "Enter a valid phone number"
      },
      "add_another": "Add another",
      "remove": "Remove this person",
      "authorized": {
        "label": "I am authorized to send text messages to these numbers"
      },
      "privacy": "When you add a text message recipient, we'll send each person a text welcoming them to Agenda Hero once they join. After that, only you control who gets a text and when. Read our <2>privacy policy</2>."
    },
    "pending_invite": {
      "expires": "Expires {{date}}",
      "expired": "Expired",
      "expired_note": "This invitation has expired",
      "resend": "Resend",
      "revoke": "Revoke",
      "revoke_confirm_title": "Revoke the invitation to {{email}}?",
      "revoke_error": "Error revoking invitation",
      "resend_success": "Invitation resent",
      "resend_error": "Error resending invitation"
    },
    "member": {
      "you": "(you)",
      "role_owner": "Owner",
      "role_editor": "Editor",
      "remove": "Remove",
      "remove_confirm_title": "Remove {{name}} from {{organization}}?",
      "remove_error": "Error removing member",
      "no_phone": "No phone number",
      "add_phone": "Add phone number",
      "edit_contact": "Edit"
    },
    "edit_contact_modal": {
      "heading": "Contact details for {{name}}",
      "name": {
        "label": "Display name for text reminders"
      },
      "phone": {
        "label": "Phone number",
        "invalid": "Enter a valid phone number"
      },
      "authorized": {
        "label": "I am authorized to send text messages to this number",
        "required": "Please confirm"
      },
      "privacy": "When you add a text message recipient, we'll send each person a text welcoming them to Agenda Hero. After that, only you control who gets a text and when. Read our <2>privacy policy</2>.",
      "save": "Save",
      "cancel": "Cancel",
      "success_toast": "Contact details saved"
    }
  },
  "create_organization": {
    "heading": "Create organization",
    "section_heading": "New organization",
    "billing_interval": "Billing interval",
    "monthly": "Monthly",
    "annual": "Annual",
    "plan_name": "Organizations",
    "billed_annually": "Billed annually. {{included}} accounts included to start.",
    "billed_monthly": "Billed monthly. {{included}} accounts included to start.",
    "per_year": "year",
    "per_month": "month",
    "feature_seats": "{{included}} accounts to start, add {{packSize}} more for {{price}}/{{period}} anytime",
    "feature_brand_kit": "Brand kit and templates",
    "feature_branded_links": "Branded URL calendar links",
    "seats_heading": "Accounts",
    "seats_included_one": "{{count}} accounts included",
    "seats_included_other": "{{count}} accounts included",
    "seats_packs": "Adding {{count}} × {{packSize}} accounts",
    "seats_total_one": "{{count}} accounts total",
    "seats_total_other": "{{count}} accounts total",
    "seats_decrease": "Remove {{count}} accounts",
    "seats_increase": "Add {{count}} accounts",
    "checkout": "Continue to checkout"
  },
  "navigation": {
    "accounts_heading": "Accounts & workspaces",
    "personal_account": "Personal account",
    "org_type_family": "Family",
    "org_type_business": "Organization",
    "role_you": "You",
    "role_owner": "Owner",
    "role_member": "Member",
    "create_organization": "Create organization",
    "account": "Profile",
    "help": "Help & support",
    "calendars": "External calendars",
    "integrations": "Canva integration"
  }
}
